module.exports = __webpack_public_path__ + "img/watermark-2.757bacf3.png";